<template>
  <div class="mainContent">
    <div class="home_list">
      <template v-if="userRole === 'system'">
        <div class="top">
          <router-link to="/trainCamp/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>精英管理</p>
              <p>Elite Management</p>
            </div>
          </router-link>
          <router-link to="/club/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>精英机构/基地管理</p>
              <p>Training Institutions Management</p>
            </div>
          </router-link>
          <router-link to="/center/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>精英机构</p>
              <p>Youth Training Center</p>
            </div>
          </router-link>
          <router-link to="/org/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>区体育行政部门</p>
              <p>SFA Member</p>
            </div>
          </router-link>
          <router-link to="/talentSendPlayer/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/playerTalent.png" alt="" />
              <p>培养成效</p>
              <p>Training Effect</p>
            </div>
          </router-link>
          <router-link to="/supervision/supervisionTrain" class="link">
            <div class="box">
              <img src="@/assets/images/home/file.png" alt="" />
              <p>督导管理</p>
              <p>Supervision Management</p>
            </div>
          </router-link>
        </div>
        <div class="center">
          <router-link to="/player/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
              <p>Player Data</p>
            </div>
          </router-link>
          <router-link to="/coach/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>教练员管理</p>
              <p>Coach Management</p>
            </div>
          </router-link>
          <router-link
            :to="
              squadInfoUrl.includes(userRole) ? '/squad/detail' : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
              <p>Team Management</p>
            </div>
          </router-link>
          <router-link to="/body/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>运动能力测试</p>
              <p>Performance Testing</p>
            </div>
          </router-link>
          <router-link to="/scout/playerScoutOneData"  class="link">
            <div class="box">
              <img src="@/assets/images/home/scout.png" alt="">
              <p>优秀苗子推荐</p>
              <p>Scouting Report</p>
            </div>
          </router-link>
          <router-link to="/statistics" class="link">
            <div class="box">
              <img src="@/assets/images/home/statistics.png" alt="" />
              <p>大数据</p>
              <p>Big Data</p>
            </div>
          </router-link>

        </div>
        <div class="bottom">
          <router-link to="/tutorial/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
              <p>Training Session Library</p>
            </div>
          </router-link>
          <router-link to="/media/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/video.png" alt="" />
              <p>视频库</p>
              <p>Video Library</p>
            </div>
          </router-link>
<!--          外边套一个周训练计划，这个隐藏掉-->
<!--          <router-link to="/training/list" class="link">-->
<!--            <div class="box">-->
<!--              <img src="@/assets/images/home/train.png" alt="" />-->
<!--              <p>训练计划</p>-->
<!--              <p>Training Plan</p>-->
<!--            </div>-->
<!--          </router-link>-->
          <router-link to="/plan/adminPlanList" class="link">
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>训练计划及总结</p>
              <p>Training Plan</p>
            </div>
          </router-link>
          <router-link to="/match/list_tournament" class="link">
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="" />
              <p>比赛信息</p>
              <p>Match Information</p>
            </div>
          </router-link>
          <!-- <router-link to="/teaching/list"  class="link" >
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="">
              <p>比赛报告</p>
              <p>Match Report</p>
            </div>
          </router-link> -->
          <router-link to="/performance/index" class="link">
            <div class="box">
              <img src="@/assets/images/home/assess.png" alt="" />
              <p>评估管理</p>
              <p>Assess Management</p>
            </div>
          </router-link>
          <router-link to="/expert/expertList" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>专家管理</p>
              <p>Expert Management</p>
            </div>
          </router-link>
        </div>
      </template>
      <template v-if="userRole === 'admin'">
        <div class="router-group" v-if="!details">
          <!--uui不为青训总监-->
          <div v-if="'88651a0d62cb500ab5b0f38e06bc5711' !== uuid" class="router-item big" :class="{ width: isInClubSystem }" @click="setBack('assess')">
            <img src="@/assets/images/home/assess.png" alt="" />
            <p>评估管理</p>
            <p>Assess Management</p>
          </div>

          <div class="router-item big" :class="{ width: isInClubSystem || '88651a0d62cb500ab5b0f38e06bc5711' === uuid }" @click="setBack('mans')">
            <img src="@/assets/images/home/player.png" alt="" />
            <p>日常管理</p>
            <p>Daily Management</p>
          </div>

          <div v-if="!isInClubSystem" class="router-item big" :class="{ width: isInClubSystem || '88651a0d62cb500ab5b0f38e06bc5711' === uuid }"  @click="jumpTo('/statistics')">
            <img src="@/assets/images/home/statistics.png" alt=""/>
            <p>大数据</p>
            <p>Big Data</p>
          </div>
        </div>
        <assess-banner v-show="details === 'assess'" />
        <mans-banner v-show="details === 'mans'" />
        <!-- <div class="bottom">
          <router-link to="/performance/index" class="link">
            <div class="box">
              <img src="@/assets/images/home/assess.png" alt="" />
              <p>评估管理</p>
              <p>Assess Management</p>
            </div>
          </router-link>
          <router-link to="/club/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>俱乐部管理</p>
              <p>Training Institutions Management</p>
            </div>
          </router-link>
          <router-link to="/center/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>青训中心管理</p>
              <p>Youth Training Center</p>
            </div>
          </router-link>
          <router-link to="/org/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>区体育行政部门</p>
              <p>SFA Member</p>
            </div>
          </router-link>
        </div> -->
        <!-- <div class="top">
          <router-link to="/trainCamp/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>精英训练营</p>
              <p>Elite Camps</p>
            </div>
          </router-link>
          <router-link
            :to="
              squadInfoUrl.includes(userRole) ? '/squad/detail' : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
              <p>Team Management</p>
            </div>
          </router-link>
          <router-link to="/player/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
              <p>Player Data</p>
            </div>
          </router-link>
          <router-link to="/coach/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>教练员管理</p>
              <p>Coach Management</p>
            </div>
          </router-link>

        </div> -->
        <!-- <div class="center">
          <router-link to="/body/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>运动能力测试</p>
              <p>Performance Testing</p>
            </div>
          </router-link>
          <router-link to="/tutorial/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
              <p>Training Session Library</p>
            </div>
          </router-link>
          <router-link to="/training/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>训练计划</p>
              <p>Training Plan</p>
            </div>
          </router-link>
          <router-link to="/media/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/video.png" alt="" />
              <p>视频库</p>
              <p>Video Library</p>
            </div>
          </router-link>
        </div> -->
      </template>
      <template v-if="userRole === 'expert' && !isInClubSystem">

        <div class="top">
          <!--<router-link to="/expert/list" class="link">-->
            <!--&lt;!&ndash; to="/performance/phaselist" &ndash;&gt;-->
            <!--<div class="box">-->
              <!--<img src="@/assets/images/home/assess.png" alt="" />-->
              <!--<p>评估管理</p>-->
              <!--<p>Assess Management</p>-->
            <!--</div>-->
          <!--</router-link>-->

          <router-link to="/supervision/indexSupervisionExpert" class="link">
            <div class="box">
              <img src="@/assets/images/home/file.png" alt="" />
              <p>督导管理</p>
              <p>Supervision Management</p>
            </div>
          </router-link>
          <router-link to="/scout/list"  class="link">
            <div class="box">
              <img src="@/assets/images/home/scout.png" alt="">
              <p>优秀苗子推荐</p>
              <p>Scouting Report</p>
            </div>
          </router-link>
          <router-link to="/player/playerSearch" class="link">
            <div class="box">
              <img src="@/assets/images/home/personSearch.png" alt="" />
              <p>球员搜索</p>
              <p>Player Search</p>
            </div>
          </router-link>
          <a href="/uploads/templateFile/督导用户--上海市青少年足球精英培训基地综合服务管理平台基地管理员说明手册V1.0.pdf" class="link" target="_blank">
            <!-- to="/performance/phaselist" -->
            <div class="box">
              <img src="@/assets/images/home/assess.png" alt="" />
              <p>操作手册</p>
              <p>Operation Manual</p>
            </div>
          </a>
          <!--<router-link to="/center/list" class="link">-->
            <!--<div class="box">-->
              <!--<img src="@/assets/images/home/organ.png" alt="" />-->
              <!--<p>精英机构</p>-->
              <!--<p>Youth Training Center</p>-->
            <!--</div>-->
          <!--</router-link>-->
          <!--<router-link to="/record/list" class="link">-->
            <!--<div class="box">-->
              <!--<img src="@/assets/images/home/playerTalent.png" alt="" />-->
              <!--<p>培养成效</p>-->
              <!--<p>Training Effect</p>-->
            <!--</div>-->
          <!--</router-link>-->

        </div>
        <!--<div class="bottom">-->
          <!---->
        <!--</div>-->
      </template>
      <template v-if="userRole === 'expert' && isInClubSystem">
        <div class="router-group">
          <!-- @click="setBack('assess')" -->
          <div class="router-item big width" @click="jumpTo('/expert/list')">
            <img src="@/assets/images/home/assess.png" alt="" />
            <p>评估管理</p>
            <p>Assess Management</p>
          </div>
          <div class="router-item big width" @click="jumpTo('/setting/personal')">
            <img src="@/assets/images/home/player.png" alt="" />
            <p>个人设置</p>
            <p>Setting</p>
          </div>
        </div>
      </template>
      <template v-if="userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">
        <div class="top">
          <template v-if="isVisibleInHome">
            <router-link :to="linkPath" class="link">
              <!-- to="/performance/phaselist" -->
              <div class="box">
                <img src="@/assets/images/home/assess.png" alt="" />
                <p>评估管理</p>
                <p>Assess Management</p>
              </div>
            </router-link>
          </template>
          <template v-else>
            <router-link :to="'/'" class="link">
              <!-- to="/performance/phaselist" -->
              <div class="box">
                <img src="@/assets/images/home/assess.png" alt="" />
                <p>评估管理</p>
                <p>Assess Management</p>
              </div>
            </router-link>
          </template>

          <router-link
            v-if="userRole === 'youth'"
            to="/center/setting"
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/set.png" alt="" />
              <!-- <p>青训中心信息设置</p> -->
              <p>组织管理</p>
              <p>Setting</p>
            </div>
          </router-link>

          <router-link
            v-if="userRole === 'club'"
            to="/club/setting"
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/set.png" alt="" />
              <p>信息设置</p>
              <p>Setting</p>
            </div>
          </router-link>

          <router-link to="/tutorial/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
              <p>Training Session Library</p>
            </div>
          </router-link>

          <router-link to="/plan/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>训练计划及总结</p>
              <p>Training Plan</p>
            </div>
          </router-link>
        </div>
        <div class="bottom">
          <router-link v-if="userRole === 'youth'|| userRole === 'club'" to="/school/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>体教融合</p>
              <p>Sports and Education</p>
            </div>
          </router-link>
          <router-link v-if="userRole === 'youth'|| userRole === 'club'" to="/siteFacilities/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/siteFacilities.png" alt="" />
              <p>场地设施</p>
              <p>Site Facilities</p>
            </div>
          </router-link>
          <router-link v-if="userRole === 'youth'|| userRole === 'club'" to="/talentSendPlayer/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/playerTalent.png" alt="" />
              <p>培养成效</p>
              <p>Training Effect</p>
            </div>
          </router-link>

          <router-link
            v-if="userRole === 'trainCamp'"
            to="/trainCamp/setting"
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>精英集训队信息设置</p>
              <p>Setting</p>
            </div>
          </router-link>
          <router-link to="/body/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>运动能力测试</p>
              <p>Performance Testing</p>
            </div>
          </router-link>

          <router-link to="/match/list_tournament" class="link">
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="" />
              <p>比赛信息</p>
              <p>Match Information</p>
            </div>
          </router-link>
        </div>
        <div class="bottom">
          <router-link
            :to="
              squadInfoUrl.includes(userRole) ? '/squad/detail' : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
              <p>Team Management</p>
            </div>
          </router-link>

          <router-link to="/coach/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>教练员管理</p>
              <p>Coach Management</p>
            </div>
          </router-link>

          <router-link to="/player/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
              <p>Player Data</p>
            </div>
          </router-link>

<!--          暂时隐藏-->
          <router-link to="/statisticsYouth" class="link" v-if="!isInClubSystem">
          <div class="box">
            <img src="@/assets/images/home/statistics.png" alt="" />
            <p>大数据</p>
            <p>Big Data</p>
          </div>
        </router-link>

          <router-link to="/scout/list"  class="link">
          <div class="box">
          <img src="@/assets/images/home/scout.png" alt="">
          <p>优秀苗子推荐</p>
          <p>Scouting Report</p>
          </div>
          </router-link>
        </div>
      </template>
      <template v-if="userRole === 'organ'">
        <div class="top">
          <router-link to="/performance/orgCheck" class="link">
            <div class="box">
              <img src="@/assets/images/home/assess.png" alt="" />
              <p>区级初审管理</p>
              <p>Assess Management</p>
            </div>
          </router-link>
          <router-link to="/org/setting" class="link">
            <div class="box">
              <img src="@/assets/images/home/set.png" alt="" />
              <p>信息设置</p>
              <p>Setting</p>
              <!-- <p>评估管理</p>
              <p>Assess Management</p> -->
            </div>
          </router-link>
        </div>
        <!-- <div class="top" style="margin-bottom: 100px">
          <router-link to="/performance/orgCheck" class="link">
            <div class="box">
              <img src="@/assets/images/home/assess.png" alt="" />
              <p>评估管理</p>
              <p>Assess Management</p>
            </div>
          </router-link>
          <router-link to="/coach/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>教练员管理</p>
              <p>Coach Management</p>
            </div>
          </router-link>
          <router-link to="/scout/list"  class="link">
          <div class="box">
          <img src="@/assets/images/home/body.png" alt="">
          <p>优秀苗子推荐</p>
          <p>Performance Testing</p>
          </div>
          </router-link>
          <router-link to="/trainCamp/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/organ.png" alt="" />
              <p>精英集训队</p>
              <p>Elite Player Team</p>
            </div>
          </router-link>
        </div> -->
        <!-- <div class="center">
          <router-link to="/player/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
              <p>Player Data</p>
            </div>
          </router-link>
          <router-link
            :to="
              squadInfoUrl.includes(userRole) ? '/squad/detail' : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
              <p>Team Management</p>
            </div>
          </router-link>
          <router-link to="/body/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>运动能力测试</p>
              <p>Performance Testing</p>
            </div>
          </router-link>
        </div> -->
      </template>
      <template v-if="userRole === 'player'">
        <div class="top">
          <router-link
            :to="{ path: '/player/info', query: { uuid: uuid } }"
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>我的数据</p>
              <p>My Data</p>
            </div>
          </router-link>
          <router-link to="/tutorial/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
              <p>Training Session Library</p>
            </div>
          </router-link>
        </div>
        <div class="center">
          <router-link
            :to="
              squadInfoUrl.includes(userRole) ? '/squad/detail' : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/teacher.png" alt="" />
              <p>我的球队</p>
              <p>My Team</p>
            </div>
          </router-link>
          <router-link to="/media/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/video.png" alt="" />
              <p>视频库</p>
              <p>Video Library</p>
            </div>
          </router-link>
        </div>
        <div class="bottom">
          <router-link to="/training/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>我的训练计划及总结</p>
              <p>My Training Plan</p>
            </div>
          </router-link>
          <router-link to="/teaching/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="" />
              <p>我的比赛报告</p>
              <p>My Match Report</p>
            </div>
          </router-link>
        </div>
      </template>
      <template v-if="userRole === 'leader' || userRole === 'coach'">
        <div class="top" style="margin-bottom: 100px">
          <!-- <router-link :to='squadInfoUrl.includes(userRole)? "/squad/detail" : "/squad/list" ' class="link"> -->
          <router-link
            :to="
              squadInfoUrl.includes(userRole)
                ? '/squad/squadList'
                : '/squad/list'
            "
            class="link"
          >
            <div class="box">
              <img src="@/assets/images/home/squad.png" alt="" />
              <p>球队管理</p>
              <p>Team Management</p>
            </div>
          </router-link>
          <router-link to="/player/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/player.png" alt="" />
              <p>球员数据</p>
              <p>Player Data</p>
            </div>
          </router-link>
<!--          训练计划外套一个周计划-->
<!--          <router-link to="/training/list" class="link">-->
<!--            <div class="box">-->
<!--              <img src="@/assets/images/home/train.png" alt="" />-->
<!--              <p>训练计划</p>-->
<!--              <p>Training Plan</p>-->
<!--            </div>-->
<!--          </router-link>-->

          <router-link to="/tutorial/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/library.png" alt="" />
              <p>教案库</p>
              <p>Training Session Library</p>
            </div>
          </router-link>
          <router-link to="/scout/list"  class="link">
          <div class="box">
          <img src="@/assets/images/home/scout.png" alt="">
          <p>优秀苗子推荐</p>
          <p>Scouting Report</p>
          </div>
          </router-link>
        </div>
        <div class="center">
          <router-link to="/plan/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/train.png" alt="" />
              <p>训练计划及总结</p>
              <p>Training Plan</p>
            </div>
          </router-link>
          <router-link to="/match/list_tournament" class="link">
            <div class="box">
              <img src="@/assets/images/home/match.png" alt="" />
              <p>比赛信息</p>
              <p>Match Information</p>
            </div>
          </router-link>
          <router-link to="/media/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/video.png" alt="" />
              <p>视频库</p>
              <p>Video Library</p>
            </div>
          </router-link>
          <router-link to="/body/list" class="link">
            <div class="box">
              <img src="@/assets/images/home/body.png" alt="" />
              <p>运动能力测试</p>
              <p>Performance Testing</p>
            </div>
          </router-link>
        </div>
      </template>
      <yioks-tip
        :showTip="showCoachLimitDate"
        :tipMsg="tips"
        :confirmBtn="$t('iKnow')"
        @callback="coachLimitDateConfirmCallback"
      />
      <yioks-tip
        :showTip="showCoachLimitClub"
        :tipMsg="tipsClub"
        :confirmBtn="$t('iKnow')"
        @callback="coachLimitClubConfirmCallback"
      />
    </div>
  </div>
</template>

<script>
import storage from "@/utils/storage";
import common from "@/api/common";
import pay from "@/api/pay";
import coach from "@/api/coach";
import rsyncRegion from "@/api/common/rsyncRegion";
import mixinForRouter from "@/views/performance/mixinForRouter";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import yioksStorage from "@/assets/js/yioksStorage";
import store from "../../store";
import auth from '@/api/auth'

export default {
  name: "Home",

  mixins: [mixinForRouter, mixinAppConfig],
  components: {
    "assess-banner": () => import("./AssessBanner"),
    "mans-banner": () => import("./MansBannner"),
  },
  data() {
    return {
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      squadInfoUrl: ["coach", "leader", "player"],
      showCoachLimitDate: false,
      showCoachLimitClub: false,
      tips: '',
      tipsClub: '',
    };
  },
  computed: {
    details() {
      const { details } = this.$route.query;
      return details;
    },
  },
  created() {
    this.getUserInfo(); // 获取用户信息
    this.getRenewYouthNum(); // 获取俱乐部开通教练员数量
    this.getCoachLimitDate(); // 获取教练是否到期
    this.checkCoachStatus(); // 获取教练是否到期
    rsyncRegion();
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      common.getUserInfo().then((res) => {
        if(res.userStatus !=='EFFECTIVE'){
          this.dropOut(true);
        }
      });
    },
    dropOut (isSure) {
      if (isSure) {
        auth.logout().then(res => {
          storage.remove('token')
          storage.remove('loginToken')
          storage.remove('createPlan')
          this.$store.commit('clearHeart')
          this.$router.push({
            path: '/login',
            query: {}
          })
        })
      }
    },
    // 获取俱乐部开通教练员数量
    getRenewYouthNum() {
      if(this.userRole === 'youth' || this.userRole === 'club'){
        pay.getRenewYouthNum().then((res) => {
          storage.set('renewYouthNum', Number(res)||0);
          this.$store.commit("setRenewYouthNum");
        });
      }
    },
    checkCoachStatus(){
      console.log(storage.get("showCoachLimitWarn"))
      if(this.userRole === 'youth' || this.userRole === 'club'){
        if(storage.get("showCoachLimit") === 1){
          if(!storage.get("showCoachLimitWarn") || storage.get("showCoachLimitWarn") < new Date().getTime() - 30 * 24 * 60 * 60 * 1000){
            coach.checkCoachStatus().then((res) => {
              console.log(res.length)
              if(res){
                this.showCoachLimitClub = true;
                this.tipsClub = res.length + '个教练员帐号已到期或一个月内即将到期，到期后将不能编写教案和训练计划，为不影响其使用请尽快续费。';
              }
            });
          }
        }
      }
    },
    // 获取俱乐部开通教练员数量
    getCoachLimitDate() {
      if(this.userRole === 'coach'){
        coach.getCoachLimitDate().then((res) => {
          if(res.expire){
            this.showCoachLimitDate = true;
            this.tips = '教练员帐号将于' + res.coachLimitDate +'到期，请尽快联系上级机构进行开通后登录。';
          }
        });
      }
    },
    setBack(val) {
      if ("assess" === val) {
        this.$router.push({
          // path: '/performance/orgCheck',
          path: "/performance/index",
        });
      } else {
        this.$router.replace({
          path: this.$route.path,
          query: {
            details: val,
          },
        });
      }
    },
    jumpTo(path) {
      this.$router.push({
        path: path,
        // query: {
        //   details: val,
        // },
      });
    },
    // 俱乐部/机构获取待续费教练数量

    // 教练到期时间限制
    coachLimitDateConfirmCallback(isSure) {
      this.showCoachLimitDate = false;
    },
    coachLimitClubConfirmCallback(isSure) {
      this.showCoachLimitClub = false;
      storage.set('showCoachLimit', 0);
      storage.set('showCoachLimitWarn', new Date().getTime());
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.mainContent
  display flex
  justify-content center
  align-items center
  height 100%
.home_list
  width 950px
  .top, .bottom, .center
    display flex
    justify-content center
    margin-bottom 30px
    .link
      width 280px
      flex 1 1 auto
      margin 0 20px
      .box
        height 200px
        width 100%
        display flex
        justify-content center
        align-items center
        flex-direction column
        p
          text-align center
    a
      background $black_color
      box-sizing border-box
      margin-right 30px
      border 2px solid transparent
      display flex
      justify-content center
      align-items center
      flex-direction column
      font-size 24px
      &:hover
        border 2px solid $green_color
        box-shadow inset 0 0 12px $green_color
        background rgba(0, 0, 0, 0.7) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
        background-size 140px 204px
      &:last-child
        margin-right 0
      p
        &:last-child
          margin-top 12px
          font-size 16px
      img
        width 55px
        height 55px
        margin-bottom 5px
  .bottom
    margin-bottom
      /* height 250px */
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.router-group
  width 100%
  font-size 16px
  display flex
  flex-wrap wrap
  justify-content space-around
  .router-item
    background $black_color
    color $color_white
    text-align center
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 200px
    margin 20px 10px
    min-width 190px
    width calc(35% - 40px)
    cursor pointer
    user-select none
    &.width
      width calc(50% - 40px)
    &.big
      height 200px
      margin 20px 10px
      min-width 270px
    &:hover
      border 2px solid $green_color
      box-shadow inset 0 0 12px $green_color
      background rgba(0, 0, 0, 0.7) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
      background-size 140px 204px

    img
      width 55px
      height 55px
      margin-bottom 5px
    p
      font-size 24px
      margin-bottom 10px
      &+p
        font-size 16px
</style>
